import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgForward = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 10" {...props}>
    <path
      fill="none"
      stroke="#007AFF"
      d="M1.039 9.978c-.218-2.063.359-4.79 4.938-6.896C5.633 2.378 5.301 1.684 4.98 1l7.201 1.027-3.746 5.961-.744-1.632c-2.364 0-4.582 1.207-6.652 3.622z"
    />
  </svg>
);
const Memo = memo(SvgForward);
export default Memo;
